<app-responsive-topbar [status]="status" [isPreview]="template.isPreview$"></app-responsive-topbar>
<div class="bg-container centered">
    <router-outlet>
    </router-outlet>
</div>
